<template>
	<h1>Modifier niveaux</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="level">Niveaux</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Name"
				placeholder="Name"
			/>
		</div>
		<div class="input-container">
			<label for="level">Ordre</label>
			<input
				type="number"
				class="form-control"
				v-model="form.order"
				id="Name"
			/>
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				level: '',
				order: null
			},
			errors: '',
		}
	},
	methods: {
		submit() {
			this.$store.dispatch('updateLevel', this.form)
				.then(() => {
					this.$router.push({ name: 'SuperAdminAllLevels' })
				})
				.catch((error) => {
					this.errors = error
				})
		},
		getlevel() {
			authenticatedApiFetch(`/levels/${this.$route.params.id}/`, { method: 'GET' })
				.then(res => res.json())
				.then(res => {
					this.form = res
				})
		},
	},
	created() {
		this.getlevel()
	},
}
</script>

<style>
</style>
